// Single source of truth for the current filmmaker-upload terms version.
// Bump this whenever /app/frontend/src/pages/FilmmakerTerms.jsx is meaningfully
// updated — the value is sent to the backend on every upload and stored on the
// film record so we have a tamper-evident audit trail of which version each
// filmmaker accepted at the moment of upload.
export const FILMMAKER_TERMS_VERSION = "1.0";
export const FILMMAKER_TERMS_EFFECTIVE_DATE = "2026-05-01";
